export function showToast(message, type = "alert") {
  let container = document.querySelector(".toast-container")
  if (!container) {
    container = document.createElement("div")
    container.className = "toast-container fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex flex-col gap-3"
    document.body.appendChild(container)
  }

  const toast = document.createElement("div")
  toast.className = "toast"
  toast.setAttribute("data-controller", "flash")

  const icon = type === "notice"
    ? `<svg class="w-5 h-5 text-green-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>`
    : `<svg class="w-5 h-5 text-red-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>`

  toast.innerHTML = `
    <div class="flex items-center gap-3">
      ${icon}
      <span class="font-fira text-sm text-white">${escapeHtml(message)}</span>
      <button type="button" class="text-white/60 hover:text-white ml-2 shrink-0" data-action="flash#dismiss">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  `

  container.appendChild(toast)

  setTimeout(() => {
    toast.classList.add("toast-exit")
    setTimeout(() => toast.remove(), 200)
  }, 5000)
}

function escapeHtml(unsafe) {
  return String(unsafe)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#039;")
}
